export const ReportsConstants = {
    GETCOUNSELLOR_REPORT: 'GETCOUNSELLOR_REPORT',
    COUNSELLOR_REPORT_SUCCESS: 'COUNSELLOR_REPORT_SUCCESS',
    COUNSELLOR_REPORT_FAILURE: 'COUNSELLOR_REPORT_FAILURE',
    
    GETCORPORATE_REPORT:'GETCORPORATE_REPORT' ,
    CORPORATE_REPORT_SUCCESS:'CORPORATE_REPORT_SUCCESS' ,
    CORPORATE_REPORT_FAILURE:'CORPORATE_REPORT_FAILURE',

    RESET_REPORTS:'RESET_REPORTS'
}


// WEBPACK FOOTER //
// ./src/store/constants/reports.constants.js